import axios, { AxiosResponse } from "axios";
import { api } from "../../data/urls";
import returnAuthHeaderForAJAX from "../auth/returnAuthHeaderForAJAX";

type ClonePostAsync = (payload: {
  accessToken: string;
  subdomain: string;
  postUrl: string;
}) => Promise<AxiosResponse<any>>;

export const clonePostAsync: ClonePostAsync = ({
  accessToken,
  subdomain,
  postUrl,
}) => {
  return new Promise((resolve, reject) => {
    const apiUrl =
      api.blogPosts.cloneBlogPost.prefix +
      subdomain +
      "/" +
      postUrl +
      api.blogPosts.cloneBlogPost.postfix;

    axios
      .post(apiUrl, {}, { ...returnAuthHeaderForAJAX(accessToken) })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
